import graphql from 'graphql-tag'
export const GET_ORGANISATION_TYPE = graphql`
  query GetOrganisationType($organisationId: String!) {
    getOrganisationById(organisationId: $organisationId) {
      organisationType
    }
  }
`
